<template>
<div class="monitor">
  <div class="title">
    <el-breadcrumb>
      <el-breadcrumb-item>检测套餐</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="main">
    <el-card>
      <div class="subTitle">
        <p>优惠券码</p>
        <span>多种工具助力营销</span>
      </div>
      <div class="list" v-if="marketing_open && appList.length > 0">
        <el-row :gutter="40">
          <el-col :span="6" class="item" v-for="(item, index) in appList" :key="index">
            <div class="ibox" :style="`background:url(${item.background})`" @click="routeTo(item)">
              <div class="img">
                <el-image :src="item.img"></el-image>
              </div>
              <div class="text">
                <p>{{ item.name }}</p>
                <span>{{ item.sub_title }}</span>
              </div>
            </div>
            <el-button-group class="btns" v-if="item.code == 'SMS_SERVICE'">
              <el-button type="primary" class="primary" @click="showPay(item.id)" v-if="item.merchant_status== 0">套餐充值</el-button>
            </el-button-group>
            <el-button-group class="btns" v-else>
              <el-button type="info" class="info">支持先用后付</el-button>
              <el-button type="primary" class="primary" @click="showPay(item.id)" v-if="item.merchant_status== 0">待开通</el-button>
              <el-button type="info" class="info" v-else style="border:1px solid #ccc;background:#fff">已开通</el-button>
              <!--  <el-button type="primary" class="primary" @click="showPay(item.id)" v-else>待开通</el-button> -->
            </el-button-group>
          </el-col>
        </el-row>
      </div>
      <el-empty description="暂无应用！" v-else></el-empty>
    </el-card>
  </div>
  <PayDia ref="payDia" @step="step" :comboList="comboList"></PayDia>
  <PayDiaStep1 ref="PayDiaStep1" @step1="step1" :itemData="itemData"></PayDiaStep1>
  <PayDiaStep2 ref="PayDiaStep2" :itemData="itemData" :id="id"></PayDiaStep2>
  <shortPay ref="shortPay" :appId="id"></shortPay>
</div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapActions
} from "vuex";
import shortPay from "./common/shortPay.vue";
import PayDia from "./common/payDia.vue";
import PayDiaStep1 from "./common/payDiaStep1.vue";
import PayDiaStep2 from "./common/payDiaStep2.vue";
export default {
  data() {
    return {
      img: require("@/assets/icon/icon_jianctc.png"),
      appList: [],
      marketing_open: false,
      comboList: [],
      itemData: null,
      id: "",
    };
  },
  components: {
    PayDia,
    PayDiaStep1,
    PayDiaStep2,
    shortPay
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  created() {
    this.getApplicationFunc();
  },
  methods: {
    ...mapMutations({
      setAppVerify: "setAppVerify",
    }),
    ...mapActions({
      adminApplication: "activity/adminApplication",
      applicationCombo: "detect/applicationCombo",
    }),
    getCombo(id) {
      let params = {
        id: id,
        token: this.getToken,
      };
      this.applicationCombo(params).then(({
        data
      }) => {
        if (data.code == 1) {
          this.comboList = data.data;
          // this.comboList = [...data.data, ...data.data, ...data.data];
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    routeTo() {},
    getApplicationFunc() {
      this.adminApplication({
        token: this.getToken
      }).then(({
        data
      }) => {
        if (data.code == 1) {
          this.setAppVerify(data.data.list);
          data.data.list.forEach((item) => {
            if (item.code == "CONSOLE_TOOL") {
              item.img = require("@/assets/icon/icon_jianctc.png");
              item.background = require("@/assets/icon/img_beij.png");
              this.id = item.id;
            }
            /* this.$route.query.type == "short" */
            if (item.code == "SMS_SERVICE") {
              item.img = require("@/assets/icon/icon_jianctc.png");
              item.background = require("@/assets/icon/img_beij.png");
              this.id = item.id;
            }

            //detection
            /*     switch (item.code) {
                    case "CONSOLE_TOOL":
                        item.img = require("@/assets/icon/icon_jianctc.png");
                        item.background = require("@/assets/icon/img_beij.png");
                        this.id = item.id;
                        break;
                    default:
                        break;
                } */
            if (item.code == "CONSOLE_TOOL") {
              this.appList.push(item);
              if (item.status == 1) {
                this.marketing_open = true;
              }
            }
            if (item.code == "SMS_SERVICE") {
              this.appList.push(item);
              if (item.status == 1) {
                this.marketing_open = true;
              }
            }
          });
        }
      });
    },
    step1() {
      this.$refs.PayDiaStep2.dialogVisible = true;
      this.$refs.PayDiaStep2.getPayId();
    },
    step(item) {
      this.itemData = JSON.parse(JSON.stringify(item));
      this.$refs.PayDiaStep1.dialogVisible = true;
    },
    showPay(id) {
      if (id == 10) {
        this.$nextTick(()=>{
          this.$refs.shortPay.viewDetail = true
          this.$refs.shortPay.getCombo(id)
        })

      } else {
        this.getCombo(id);
        this.$refs.payDia.dialogVisible = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.monitor {
  .title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
  }

  .main {
    min-width: 1200px;
    margin: 20px;

    .demo-form-inline {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .el-card {
      margin-top: 10px;
      height: 760px;

      &:first-child {
        margin-top: 0;
      }
    }

    ::v-deep .el-form--inline .el-form-item {
      margin: 10px 10px 10px 0;
    }

    .table {
      min-height: 500px;
    }
  }

  .pageSize {
    text-align: right;
    margin-top: 20px;
  }
}

::v-deep .el-table--border th.el-table__cell {
  background-color: #f8f9fe;
}

.link {
  a {
    margin: 0 8px;
  }
}

.dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #f00;
  transform: translateY(-2px);
  margin-right: 4px;
}

.dot1 {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #0094ff;
  transform: translateY(-2px);
  margin-right: 4px;
}

.subTitle {
  margin-bottom: 48px;

  p {
    display: inline-block;
    font-size: 18px;
    color: #333;
    margin-right: 10px;
    padding-left: 12px;
    position: relative;

    &::before {
      content: "";
      width: 3px;
      height: 18px;
      background: #2448ff;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  span {
    font-size: 14px;
    color: #666;
  }
}

::v-deep .el-card__body {
  padding: 40px;
}

.list {
  .item {
    width: 320px;

    .btns {
      margin-top: 22px;
      width: 100%;
      display: flex;

      .info {
        background-color: #ededed;
        border: none;
        color: #666;
      }

      .primary {
        background-color: #2448ff;
        border: none;
      }
    }

    .el-button-group>.el-button {
      flex: 1;

      span {
        line-height: 34px;
        height: 34px;
      }
    }
  }

  .ibox {
    // background: url("../../../assets/icon/img_beij.png") no-repeat;
    cursor: pointer;
    padding: 30px;
    background-size: 100% 100% !important;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 130px;

    .img {
      width: 56px;
      height: 56px;
      margin-right: 14px;
      flex-shrink: 0;
    }

    .text {
      p {
        font-size: 22px;
        color: #fff;
        font-weight: 600;
        line-height: 36px;
      }

      span {
        font-size: 12px;
        line-height: 22px;
        color: #fff;
      }
    }
  }

  .price {
    margin: 14px;
    cursor: pointer;

    .isPay {
      cursor: auto;
    }

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #ff8a00;
      font-weight: 600;

      i {
        margin-left: 14px;
        font-size: 24px;
        color: #666;
        font-weight: 600;
      }
    }
  }
}
</style>
